import { pagingToParams } from 'modules/utils';
import { ContractGroup } from 'modules/contractsPage/components/helper';
import { axiosInstance } from './axios';
import { PagingParams } from '../types/PagingParams';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getAllContracts = async (params: PagingParams) => {
  const requestParams = pagingToParams(params);

  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/contract`,
    { params: requestParams },
  );

  const {
    data: { content, totalPages },
  } = response;

  return {
    contracts: content,
    group: ContractGroup.ALL,
    totalPageCount: totalPages,
    page: params.page,
  };
};

export const getActiveContracts = async (params: PagingParams) => {
  const requestParams = pagingToParams(params);

  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/contract/active`,
    { params: requestParams },
  );

  const {
    data: { content, totalPages },
  } = response;

  return {
    contracts: content,
    group: ContractGroup.ACTIVE,
    totalPageCount: totalPages,
    page: params.page,
  };
};

export const getInactiveContracts = async (params: PagingParams) => {
  const requestParams = pagingToParams(params);

  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/contract/inactive`,
    { params: requestParams },
  );

  const {
    data: { content, totalPages },
  } = response;

  return {
    contracts: content,
    group: ContractGroup.INACTIVE,
    totalPageCount: totalPages,
    page: params.page,
  };
};

export const getContractByNumber = async (number: string) => {
  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/contract/details`,
    {
      number,
    },
  );

  return response.data;
};
